import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const postGetAdminWorkCalendarDataForProjectInTimeFrameWithSearchParams =
  async (projectId, fromDate, toDate, searchParams, activeEmployerInfo) => {
    const apiPath = `workflow/admin-request/${projectId}/${fromDate}/${toDate}/with-search-params`;

    const signedRequest = await createSignedPostRequest({
      apiPath,
      body: searchParams,
      activeEmployerInfo,
    });

    const response = await axios(signedRequest);

    return response.data;
  };
